import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UserProfileService } from '@services/user-profile.service';
import {URL_DISABLED_FOOTER} from '@modules/commom/footer/constants/footer';

declare function openChatGamora(fila): any; //NOSONAR

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent {

  constructor(private readonly router: Router,
              private readonly userProfileService: UserProfileService) {
  }

  private isUrlDisabledFooter(): boolean {
    const url: string = this.router.url.split('?')[0];
    return URL_DISABLED_FOOTER.includes(url);
  }

  public get enableContactUs(): boolean {
    const isManagerProfile = this.userProfileService.isBackOffice() || this.userProfileService.isPartner();
    const isUrlDisabledFooter = this.isUrlDisabledFooter();
    return !(isManagerProfile || isUrlDisabledFooter);
  }

}
